export interface IPayouts {
  id: number;
  service_period: Date;
  visible_date: string;
  invoice_number: string;
  status: string;
  payout_amount_gross: {
    amount: number;
    currency: string;
  };
}

export const PayoutsStatusType: IPayoutsStatus = {
  'merchant-visible': 'success',
  cancelled: 'danger',
};

export interface IPayoutsStatus {
  [key: string]: any;
}

export interface IInvoice {
  id: number;
  url: string;
}
